//
// This is manually calculated, used for sticky sidebars
export const pageHeaderDesktopHeightWithSearchBar = 140;
export const pageHeaderDesktopHeightWithSearchBarAndFilters = 210;
